import Functions from "../src/functions";

const RouterMapper = {
  "/creditSubmitService": {
    main: { module: "creditSubmitService", view: "list" },
  },
  "/availableContracts": {
    main: { module: "cosmoteAvailableContracts", view: "list" },
  },
  "/": {
    main: { module: "main", view: "list" },
  },
  "/submitPaymentInfo": {
    main: { module: "submitPaymentInfo", view: "list" },
  },
  "/thank_you": {
    main: { module: "thankYou", view: "list"}
  },
  "/error": {
    main: { module: "errorPage", view: "list"}
  },
  "/success": {
    main: { module: "payment", view: "list"}
  },
  "/fail": {
    main: { module: "payment", view: "list"}
  },
};
export default RouterMapper;
